import { Model } from '../Model.js';

var _dec, _class;
let Inbox = /*#__PURE__*/function (Inbox) {
  Inbox["ALL"] = "ALL";
  Inbox["PENDING"] = "PENDING";
  Inbox["DRAFT"] = "DRAFT";
  Inbox["READY_TO_PURCHASE"] = "READY_TO_PURCHASE";
  Inbox["PROCESSING"] = "PROCESSING";
  Inbox["READY_FOR_SHIPPING"] = "READY_FOR_SHIPPING";
  Inbox["TRACKING"] = "TRACKING";
  Inbox["IN_TRANSIT"] = "IN_TRANSIT";
  Inbox["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
  Inbox["DELIVERED"] = "DELIVERED";
  Inbox["RETURNED_TO_SENDER"] = "RETURNED_TO_SENDER";
  Inbox["INCIDENT"] = "INCIDENT";
  Inbox["ARCHIVED"] = "ARCHIVED";
  Inbox["CANCELED"] = "CANCELED";
  return Inbox;
}({});
const InboxKeys = {
  [Inbox.ALL]: 'all',
  [Inbox.PENDING]: 'pending',
  [Inbox.DRAFT]: 'draft',
  [Inbox.READY_TO_PURCHASE]: 'ready-to-purchase',
  [Inbox.PROCESSING]: 'processing',
  [Inbox.READY_FOR_SHIPPING]: 'ready-for-shipping',
  [Inbox.TRACKING]: 'tracking',
  [Inbox.IN_TRANSIT]: 'in-transit',
  [Inbox.OUT_FOR_DELIVERY]: 'out-for-delivery',
  [Inbox.DELIVERED]: 'delivered',
  [Inbox.RETURNED_TO_SENDER]: 'returned-to-sender',
  [Inbox.INCIDENT]: 'incident',
  [Inbox.ARCHIVED]: 'archived',
  [Inbox.CANCELED]: 'canceled'
};

/**
 * Plain object Inboxes representation.
 *
 */

/**
 * Serialized object Inboxes representation.
 *
 */

/**
 * Plain object Packlink's API response representation.
 *
 */

let Inboxes = (_dec = Model(), _dec(_class = class Inboxes {
  /**
   * Takes a IInboxesApiResponse from Packlink's API and returns a Inboxes.
   *
   * @param response  IInboxesApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    return new Inboxes({
      draft: response[Inbox.DRAFT],
      readyToPurchase: response[Inbox.READY_TO_PURCHASE],
      processing: response[Inbox.PROCESSING],
      readyForShipping: response[Inbox.READY_FOR_SHIPPING],
      inTransit: response[Inbox.IN_TRANSIT],
      outForDelivery: response[Inbox.OUT_FOR_DELIVERY],
      delivered: response[Inbox.DELIVERED],
      returnedToSender: response[Inbox.RETURNED_TO_SENDER],
      incident: response[Inbox.INCIDENT],
      archived: response[Inbox.ARCHIVED],
      canceled: response[Inbox.CANCELED]
    });
  }

  /**
   * Takes a serialized Inboxes and returns a Inboxes.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Inboxes.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedInboxes.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Inboxes.
   *
   */

  /**
   * Takes a serialized Inboxes and returns a Inboxes.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Inboxes.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedInboxes.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Inboxes.
   *
   */

  /**
   * Takes a serialized Inboxes and returns a Inboxes.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Inboxes.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedInboxes.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Inboxes.
   *
   */

  /**
   * Takes a serialized Inboxes and returns a Inboxes.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Inboxes.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedInboxes.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Inboxes.
   *
   */
  static deserialize(data) {
    if (!data) {
      return;
    }
    return new Inboxes(data);
  }
  /**
   * Returns a new Inboxes. Typings of the properties depend on the class type param T
   *
   */
  constructor() {
    let {
      draft = 0,
      readyToPurchase = 0,
      processing = 0,
      readyForShipping = 0,
      inTransit = 0,
      outForDelivery = 0,
      delivered = 0,
      returnedToSender = 0,
      incident = 0,
      archived = 0,
      canceled = 0
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.draft = draft;
    this.readyToPurchase = readyToPurchase;
    this.processing = processing;
    this.readyForShipping = readyForShipping;
    this.inTransit = inTransit;
    this.outForDelivery = outForDelivery;
    this.delivered = delivered;
    this.returnedToSender = returnedToSender;
    this.incident = incident;
    this.archived = archived;
    this.canceled = canceled;
  }
  getAll() {
    return this.getPending() + (this.processing || 0) + (this.readyForShipping || 0) + this.getTracking() + (this.archived || 0) + (this.canceled || 0);
  }
  getPending() {
    return (this.draft || 0) + (this.readyToPurchase || 0);
  }
  getTracking() {
    return (this.inTransit || 0) + (this.outForDelivery || 0) + (this.delivered || 0) + (this.returnedToSender || 0) + (this.incident || 0);
  }
  get(inbox) {
    switch (inbox) {
      case Inbox.ALL:
        return this.getAll();
      case Inbox.PENDING:
        return this.getPending();
      case Inbox.DRAFT:
        return this.draft || 0;
      case Inbox.READY_TO_PURCHASE:
        return this.readyToPurchase || 0;
      case Inbox.PROCESSING:
        return this.processing || 0;
      case Inbox.READY_FOR_SHIPPING:
        return this.readyForShipping || 0;
      case Inbox.TRACKING:
        return this.getTracking();
      case Inbox.IN_TRANSIT:
        return this.inTransit || 0;
      case Inbox.OUT_FOR_DELIVERY:
        return this.outForDelivery || 0;
      case Inbox.DELIVERED:
        return this.delivered || 0;
      case Inbox.RETURNED_TO_SENDER:
        return this.returnedToSender || 0;
      case Inbox.INCIDENT:
        return this.incident || 0;
      case Inbox.ARCHIVED:
        return this.archived || 0;
      case Inbox.CANCELED:
        return this.canceled || 0;
      default:
        return 0;
    }
  }

  /**
   * Returns a JSON serialized version of the Inboxes.
   *
   */
  toJSON() {
    return {
      draft: this.draft,
      readyToPurchase: this.readyToPurchase,
      processing: this.processing,
      readyForShipping: this.readyForShipping,
      inTransit: this.inTransit,
      outForDelivery: this.outForDelivery,
      delivered: this.delivered,
      returnedToSender: this.returnedToSender,
      incident: this.incident,
      archived: this.archived,
      canceled: this.canceled
    };
  }

  /**
   * Returns a clone of the Inboxes.
   *
   */
  clone() {
    return new Inboxes(this.toJSON());
  }

  /**
   * Returns whether the two Inboxes are equal.
   *
   */
  equals(inboxes) {
    if (!inboxes) {
      return false;
    }
    return this.draft === inboxes.draft && this.readyToPurchase === inboxes.readyToPurchase && this.processing === inboxes.processing && this.readyForShipping === inboxes.readyForShipping && this.inTransit === inboxes.inTransit && this.outForDelivery === inboxes.outForDelivery && this.delivered === inboxes.delivered && this.returnedToSender === inboxes.returnedToSender && this.incident === inboxes.incident && this.archived === inboxes.archived && this.canceled === inboxes.canceled;
  }
}) || _class);

export { Inbox, InboxKeys, Inboxes };
//# sourceMappingURL=Inboxes.js.map
